module.exports = __webpack_public_path__ + "static/media/video-all-mobile.c12c60a.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/video-all-mobile.mp4
// module id = VfpV
// module chunks = 0